<template>
  <v-container>
    <v-toolbar dense flat v-if="!!value">
      <v-row class="flex-nowrap">
        <v-btn-toggle
            dense
            v-model="statusGroup"
            multiple
            @change="onChange()"
        >
          <v-tooltip bottom v-for="item of value">
            <template v-slot:activator="{ on, attrs }" >
              <v-btn v-on="on" small elevation="2" :color="item.color" dense
                     :class="{ 'ml-2': item.left_space === true, 'mr-2': item.right_space === true }">
                <v-icon :color="item.icon_color">{{ item.icon }}</v-icon>
                {{ item.label }}
              </v-btn>
            </template>
            <span v-if="!!item.text">{{ item.text }}</span>
            <span v-else>{{ item.label }}</span>
          </v-tooltip>
        </v-btn-toggle>
        <v-btn
            v-if="statusGroup.length > 0 && clearable"
            small
            icon
            @click="statusGroup=[]; onChange()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-toolbar>
  </v-container>
</template>

<script>

export default {
  name: 'CommonFilterGroup',
  inheritAttrs: false,
  props: {
    value: {default: null},
    clearable: {default: true},
    itemList: {
      default() {
        return []
      }
    },
    rowFilterNames: {default: null},
  },

  components: {},

  computed: {},

  methods: {
    onChange() {
      let activeFilterNames = []
      this.statusGroup.forEach(row => activeFilterNames.push(this.value[row].name))
      this.$emit('update:filter-names', activeFilterNames)
    },
  },

  async mounted() {
    // console.log('mounted', this.value, this.statusGroup)
    if (!!this.value) {
      for (const [i, row] of this.value.entries()) {
            if (row.default === true)
              this.statusGroup.push(i)
          }
      if (this.statusGroup.length > 0)
        this.onChange()
        }
  },

  data() {
    return {
      statusGroup: [],
    }
  }
}
</script>

